import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-3">
              热门PK
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              今日话题对决精选
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-[600px] mx-auto">
              每日更新最热娱乐PK话题，明星对决、八卦投票、话题交锋，总有一场你感兴趣的大赛
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cardsData.map((card) => (
              <article
                key={card.id}
                className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="relative overflow-hidden aspect-[16/10]">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                    {card.summary}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-primary-500 text-sm font-semibold">
                    <span>立即围观</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}